import angular from 'angular';

angular
	.module('sh.truncate', [])
	.filter('shCharacters', function () {
		return function (input, chars, breakOnWord) {
			if (isNaN(chars)) return input;
			if (chars <= 0) return '';
			if (input && input.length > chars) {
				input = input.substring(0, chars);

				if (!breakOnWord) {
					var lastspace = input.lastIndexOf(' ');
					//get last space
					if (lastspace !== -1) {
						input = input.substr(0, lastspace);
					}
				} else {
					while (input.charAt(input.length - 1) === ' ') {
						input = input.substr(0, input.length - 1);
					}
				}
				return input + '...';
			}
			return input;
		};
	})
	.filter('shWords', function () {
		return function (input, words) {
			if (isNaN(words)) return input;
			if (words <= 0) return '';
			if (input) {
				var inputWords = input.split(/\s+/);
				if (inputWords.length > words) {
					input = inputWords.slice(0, words).join(' ') + '...';
				}
			}
			return input;
		};
	})
	.filter('shTruncateFilename', function () {
		return function (input, maxLength) {
			if (input.length < maxLength) {
				return input;
			}
			let ext = input.split('.').pop();
			if (ext == input || ext.length > maxLength) {
				// no file extension OR file extension super long
				ext = '';
			}
			return input.slice(0, maxLength - ext.length - 3) + '...' + ext;
		};
	});
